<template>
  <div class="product-visual">
    <img
      class="product-visual__image"
      src="/robot-1.png"
      alt="CIPOPO 桌面精灵"
      loading="lazy"
      decoding="async"
    />
  </div>
</template>

<style scoped>
.product-visual {
  position: relative;
  width: 100%;
  aspect-ratio: 6756 / 3800;
  min-height: 0;
  overflow: visible;
}

.product-visual__image {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

@media (max-width: 640px) {
  .product-visual__image {
    inset: auto;
    top: 0;
    bottom: 0;
    left: 58%;
    width: auto;
    height: 100%;
    transform: translateX(-50%);
  }
}
</style>
